var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.318,
    height: 45.959,
    viewBox: "0 0 45.318 45.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-thumbs-up",
    "data-name": "Icon feather-thumbs-up",
    d: "M27.575,17.335V9.144A6.144,6.144,0,0,0,21.431,3L13.24,21.431V43.958h23.1a4.1,4.1,0,0,0,4.1-3.481l2.826-18.431a4.1,4.1,0,0,0-4.1-4.71ZM13.24,43.958H7.1a4.1,4.1,0,0,1-4.1-4.1V25.527a4.1,4.1,0,0,1,4.1-4.1H13.24",
    transform: "translate(-0.5 -0.5)",
    fill: "none",
    stroke: "#66db9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.8b181b0dcc795f17fbf6854a29dfcc95.svg";
export { ForwardRef as ReactComponent };